"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBootstrapAccordionItem = exports.bootstrapAccordionItemProps = void 0;
const composition_api_1 = require("@vue/composition-api");
const _composables_1 = require("../../../../_composables");
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.bootstrapAccordionItemProps = {
    ..._composables_1.canBeDisabledProp,
    id: {
        type: String,
        required: true
    },
    isOpen: {
        type: Boolean,
        required: false,
        default: false
    },
    onToggle: {
        type: Function,
        required: false
    },
    label: {
        type: String,
        required: false,
        default: ''
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.useBootstrapAccordionItem = (props, ctx) => {
    const { emit } = ctx;
    const { isOpen } = composition_api_1.toRefs(props);
    /**
     * Reference to the `.accordion-collapse` element.
     */
    const collapseRef = composition_api_1.ref(null);
    /**
     * Value for the `max-height` declaration of the `.accordion-collapse` element.
     */
    const collapseMaxHeight = composition_api_1.ref('0px');
    /**
     * Opens (reveals) the `.accordion-collapse` element.
     */
    const open = () => {
        if (collapseRef.value === null) {
            throw new Error('BootstrapAccordionItem.watch(isOpen): [collapseRef.value] is [null]!');
        }
        collapseMaxHeight.value = collapseRef.value.scrollHeight + 'px';
    };
    /**
     * Collapses (closes) the `.accordion-collapse` element.
     */
    const collapse = () => { collapseMaxHeight.value = '0px'; };
    /**
     * Updates the value of the `collapseMaxHeight` ref.
     */
    const updateMaxHeight = () => { isOpen.value ? open() : collapse(); };
    composition_api_1.watch(isOpen, updateMaxHeight);
    composition_api_1.onMounted(updateMaxHeight);
    /**
     * Handles the `@click` event on the toggler button.
     */
    const onTogglerClick = () => {
        if (props.onToggle && !props.onToggle()) {
            return;
        }
        emit('toggle');
    };
    return { collapseMaxHeight, collapseRef, onTogglerClick, updateMaxHeight };
};
//# sourceMappingURL=AccordionItem.hooks.js.map